import React from 'react';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { makeStyles } from '@material-ui/core/styles';
import { muiWithStyles, MuiButton, MuiHidden, MuiAccountCircle, MuiMenu, MuiMenuItem, MuiIconButton, MuiKeyboardArrowDown, MuiTypography, MuiAddCircle } from '../MaterialUIComponents';
import { Link, Redirect } from 'react-router-dom'
import theme from '../../../assests';
import routes from '../../navigation/Routes'
import { removeDataInLS } from '../../../utils/LocalStorageUtil'

import { STEPPER_STATE_KEY_LS } from '../../../constants';
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  paper: {
    marginRight: theme.spacing(2),
  },
}));

export default function SchoolMenuListComponent(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [redirect, setRedirect] = React.useState(false);
  const [redirectToDashboard, setRedirectToDashboard] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }
  function onClickOfSchool(event, school, profileType) {
    handleClose(event)
    props.getSchoolInformationById(school._id);
    props.setActiveProfileType(profileType);
    props.updateUserActiveSchool(props.userInformation._id, props.userInformation.email, school, profileType)
    if (props.location.pathname != "/") {
      setRedirect(false)
      setRedirectToDashboard(true)
      
    }
  }
  const onClickOfCreateSchool = async (event) => {
    await props.setIsCreateNewSchool(true)
    removeDataInLS(STEPPER_STATE_KEY_LS)
    handleClose(event)
    setRedirect(true)
  }
  function renderRedirect() {
    if (redirect) {
      return (<Redirect to={{
        pathname: routes.addSchool,
        state: {
          isCreateNewSchool: true,
        }
      }} />)
    } else if (redirectToDashboard) {
      return (<Redirect to={{
        pathname: routes.main
      }} />)
    }
  }
  function getMenuItems(profiles) {
    let menuItems = []
    for (let i = 0; i < profiles.length; i++) {
      for (let j = 0; j < profiles[i].schools.length; j++) {
        let menuItem = <MenuItem onClick={(event) => onClickOfSchool(event, profiles[i].schools[j], profiles[i].profileType)} selected={props.activeSchool != undefined ? props.activeSchool._id == profiles[i].schools[j]._id : false}> <MuiTypography variant="body2" gutterBottom style={{ color: theme.palette.primary.darker }}>{profiles[i].schools[j].name + " - " + profiles[i].profileType}</MuiTypography></MenuItem>
        menuItems.push(menuItem)
      }
    }

    menuItems.push(<MenuItem style={{ padding: '0px', cursor: 'pointer' }} onClick={(event) => onClickOfCreateSchool(event)}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        padding: '8px'
      }}>
        <MuiAddCircle style={{ color: theme.palette.orange }} fontSize='small' />
        <MuiTypography variant="body2" gutterBottom style={{ paddingLeft: '5px',color:theme.palette.primary.darker }} color='inherit'>CREATE SCHOOL PROFILE</MuiTypography>
      </div>
    </MenuItem>)


    return menuItems;
  }
  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <div className={classes.root}>
      <div>
        {renderRedirect()}
        <MuiButton
          ref={anchorRef}
          aria-controls={open ? 'menu-list-grow' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
          style={theme.appBarTextItem}>
          MY SCHOOLS<MuiKeyboardArrowDown />
        </MuiButton>
        <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal placement="bottom-start">
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                    {props.userInformation.profiles && getMenuItems(props.userInformation.profiles)}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </div>
  );
}
